import React from "react";

import { DataView } from 'primereact/dataview';

import { NavBar } from "../components/NavBar";


import { waters } from "../services/waters/water";
import type { Water } from "../services/waters/water";

const WaterItem = (data: Water, index: number) => (
  <div className="mb-8 flex flex-row justify-evenly items-end">
    <div className="basis-1/2">
      <div style={{ fontWeight: "bold" }}>{data.name}</div>
      <div className="text-xs">
        <div className="flex flex-row justify-between">
          <div>
            General Hardness (GH):
          </div>
          <div>
            {Math.round(data.GH * 100) / 100}
          </div>
        </div>
        <div className="flex flex-row justify-between">
          <div>Alcalinity (KH): </div>
          <div> {Math.round(data.KH * 100) / 100}</div>
        </div>
      </div>
    </div>
    <div className="text-slate-500 text-xs">
      <div>Calcium: {data.calcium} mg/L</div>
      <div>Magnesium: {data.magnesium} mg/L</div>
      <div>Bicarbonates: {data.bicarbonates} mg/L</div>
    </div>
  </div >
)

const WaterList = (items: Water[]) => {
  if (!items || items.length === 0) return null;

  let list = items.map((product, index) => {
    return WaterItem(product, index);
  });

  return <div>{list}</div>;
};

function Waters() {
  return (
    <div>
      <NavBar active="waters" />
      <DataView value={waters} listTemplate={WaterList} rows={5} style={{ margin: 8 }} />
    </div >
  )
}

export default Waters;
